import { render } from "./CrearNegocioModal.vue?vue&type=template&id=6650e3ea"
import script from "./CrearNegocioModal.vue?vue&type=script&lang=js"
export * from "./CrearNegocioModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__